import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Logout from 'src/components/Dashboard/Views/Pages/Logout.vue'

const Signup = () => import(/* webpackChunkName: "Sigunup" */ 'src/components/System/Signup/Signup.vue');

const ForgotPassword = () => import(/* webpackChunkName: "ForgotPassword" */ 'src/components/System/ForgotPassword/ForgotPassword.vue');

const ResetPassword = () => import(/* webpackChunkName: "ResetPassword" */ 'src/components/System/ResetPassword/ResetPassword.vue');

import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

//Settings pages
const Users = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Settings/Users/UsersList.vue');
const UserForm = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Settings/Users/UserForm.vue');

const Roles = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Settings/Roles/RolesList.vue');


const VotersList = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Voters/VotersList.vue');

const BarangaysList = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Barangays/BarangaysList.vue');
const BarangayView = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Barangays/BarangayView.vue');
const BarangayAnalytics = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Barangays/BarangayAnalytics.vue');

const BarangayImportsList = () => import(/* webpackChunkName: "settings" */ 'src/components/System/BarangayImports/BarangayImportsList.vue');

const ScannedVoterUploadsList = () => import(/* webpackChunkName: "settings" */ 'src/components/System/ScannedVoterUploads/ScannedVoterUploadsList.vue');


const UserProfile = () => import(/* webpackChunkName: "UserProfile" */ 'src/components/System/Profile/UserProfile.vue');


const SettingsList = () => import(/* webpackChunkName: "settings" */ 'src/components/System/Settings/Setting/SettingsList.vue');


let SettingsMenu = {
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings',
  children: [
    {
      path: 'users',
      name: 'Users',
      component: Users
    },
    {
      path: 'users/:id/edit',
      name: 'UserEdit',
      component: UserForm
    },
    {
      path: 'roles',
      name: 'Roles',
      component: Roles
    },
    {
      path: 'configure',
      name: 'Settings',
      component: SettingsList
    },
 ]
}

let UserProfileMenu = {
  path: '/my-profile',
  component: DashboardLayout,
  redirect: '',
  children: [
    {
      path: '',
      name: 'UserProfile',
      component: UserProfile
    },
 ]
}

let VotersMenu = {
  path: '/voters',
  component: DashboardLayout,
  redirect: '/voters/list',
  children: [
    {
      path: 'list',
      name: 'VotersList',
      component: VotersList
    },
  ]
}


let ImportsMenu = {
  path: '/imports',
  component: DashboardLayout,
  redirect: '/imports/list',
  children: [
    {
      path: 'list',
      name: 'BarangayImportsList',
      component: BarangayImportsList
    },
  ]
}

let UploadsMenu = {
  path: '/uploads',
  component: DashboardLayout,
  redirect: '/uploads/list',
  children: [
    {
      path: 'list',
      name: 'ScannedVoterUploadsList',
      component: ScannedVoterUploadsList
    },
  ]
}

let BarangaysMenu = {
  path: '/barangays',
  component: DashboardLayout,
  redirect: '/barangays/list',
  children: [
    {
      path: 'list',
      name: 'BarangaysList',
      component: BarangaysList
    },
    {
      path: ':id/view',
      name: 'BarangayView',
      component: BarangayView
    },
    {
      path: ':id/analytics',
      name: 'BarangayAnalytics',
      component: BarangayAnalytics
    },
  ]
}

let AccountMenu = {
  path: '/account',
  component: DashboardLayout,
  redirect: '/account/info',
  children: [
    {
      path: 'info',
      name: 'UserInfo',
      component: User
    },
  ]
}

let logoutMenu = {
  path: '/logout',
  component: DashboardLayout,
  redirect: '/logout/user',
  children: [
    {
      path: 'user',
      name: 'Logout',
      component: Logout
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Signup
}

let ForgotPasswordPage = {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: ForgotPassword
}

let resetPasswordPage = {
  path: '/reset-password',
  name: 'ResetPassword',
  component: ResetPassword
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DashboardLayout,
    redirect: '/overview',
  },
  BarangaysMenu,
  UploadsMenu,
  ImportsMenu,
  VotersMenu,
  AccountMenu,
  UserProfileMenu,
  SettingsMenu,
  loginPage,
  logoutMenu,
  registerPage,
  ForgotPasswordPage,
  resetPasswordPage,
  lockPage,
  {
    path: '',
    component: DashboardLayout,
    redirect: '/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      }
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
